"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var loading_modal_1 = __importDefault(require("../../../components/loading_modal"));
var edit_child_fields_1 = __importDefault(require("./edit-child-fields"));
exports.default = (function (_a) {
    var groupedSubscription = _a.groupedSubscription, bundleType = _a.bundleType, customerId = _a.customerId;
    var _b = __read((0, react_1.useState)(false), 2), showEditNameFields = _b[0], setShowEditNameFields = _b[1];
    var _c = __read((0, react_1.useState)(false), 2), isLoading = _c[0], setIsLoading = _c[1];
    var _d = __read((0, react_1.useState)(false), 2), isError = _d[0], setIsError = _d[1];
    // specify bundle types with diapers
    // used to only show copy for free birthday gifts for diaper bundles
    var diaperBundleTypes = ['Diaper', 'Training Pant'];
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(loading_modal_1.default, { isLoading: isLoading, error: isError }),
        react_1.default.createElement("div", { className: 'account-container' },
            react_1.default.createElement("div", { className: 'alert alert--warning padding-vertical-3' },
                !showEditNameFields && diaperBundleTypes.includes(bundleType) && (react_1.default.createElement("div", { className: 'flex-container padding-vertical-3' },
                    react_1.default.createElement("span", { className: 'padding-right-3' }, "\uD83C\uDF81"),
                    react_1.default.createElement("span", null, window.accountApp.settings.nameBundleAlertText))),
                react_1.default.createElement("div", null,
                    react_1.default.createElement("a", { className: 'alert-title text-underline padding-left-6', onClick: function () {
                            setShowEditNameFields(!showEditNameFields);
                        } }, "Personalize your bundle"),
                    react_1.default.createElement("button", { className: 'float-right', onClick: function () {
                            setShowEditNameFields(!showEditNameFields);
                        } },
                        react_1.default.createElement("i", { className: 'ss-write text-black' }))),
                showEditNameFields && (react_1.default.createElement(edit_child_fields_1.default, { groupedSubscription: groupedSubscription, bundleInfo: groupedSubscription.bundleInfo, bundleType: bundleType, customerId: customerId, setIsLoading: setIsLoading, setIsError: setIsError }))))));
});
